"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MicOutlined_1 = __importDefault(require("@material-ui/icons/MicOutlined"));
const MicOffOutlined_1 = __importDefault(require("@material-ui/icons/MicOffOutlined"));
const VolumeIndicator_1 = __importDefault(require("../VolumeIndicator"));
const IconButton_1 = __importDefault(require("../IconButton"));
const styles_1 = __importDefault(require("./styles"));
const MicToggle = ({ id = 'mic', label, loading = false, onChange, track = null, value, }) => {
    const classes = styles_1.default({ value });
    const ActiveComponent = track ? (react_1.default.createElement(VolumeIndicator_1.default, { id: track.name, track: track })) : (react_1.default.createElement(MicOutlined_1.default, null));
    return (react_1.default.createElement(IconButton_1.default, { id: id, label: label, disabled: loading, loading: loading, onClick: () => onChange(!value), ariaLabel: id },
        react_1.default.createElement("span", { className: classes.icon }, value ? ActiveComponent : react_1.default.createElement(MicOffOutlined_1.default, null))));
};
exports.default = MicToggle;
